<script setup lang="ts">
import LoadingIcon from '~/components/atoms/icons/LoadingIcon.vue'

defineProps<{
  isActive: boolean
}>()
</script>

<template>
  <div>
    <Transition>
      <div v-show="isActive" class="root">
        <div class="background" />
        <div class="container">
          <LoadingIcon />
          <div class="loading-label"><span>Loading...</span></div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.root {
  position: fixed;
  z-index: 2000; // TODO: z-indexは変数管理したい
  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(10, 10, 10, 0.7);
  }
  .container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .loading-label {
      margin-top: 8px;
      span {
        color: var(--semantic-tokens-neutral-default-text);
      }
    }
  }
}
</style>
